document.addEventListener('DOMContentLoaded', function() {
  // Premium AI Chatbot - Geïsoleerd in een IIFE om conflicten te voorkomen
  (function() {
    // DOM-elementen ophalen
    const chatbot = document.getElementById('premium-ai-chatbot');
    if (!chatbot) return; // Stop als chatbot niet bestaat
    
    const button = document.getElementById('chatbot-toggle-btn');
    const panel = chatbot.querySelector('.chatbot-panel');
    const closeButton = chatbot.querySelector('.chatbot-close');
    const messagesContainer = chatbot.querySelector('.chatbot-messages');
    const form = chatbot.querySelector('.chatbot-form');
    const input = chatbot.querySelector('.chatbot-input');
    const notification = chatbot.querySelector('.chatbot-notification');
    const productsContainer = chatbot.querySelector('.product-recommendations-container');
    const productsContent = chatbot.querySelector('.product-recommendations-content');
    const recommendationsBadge = chatbot.querySelector('.recommendations-badge');
    
    // State variabelen
    let isOpen = false;
    let isTyping = false;
    let conversationHistory = []; // Voor context in API-aanroepen
    let recommendedProducts = []; // Voor productaanbevelingen
    
    // Config - Haal instellingen op uit data-attributen
    const config = {
      welcomeMessage: chatbot.getAttribute('data-welcome-message') || 'Hallo! Waarmee kan ik u helpen?',
      position: chatbot.getAttribute('data-position') || 'bottom-right',
      shopUrl: window.location.origin,
      apiKey: chatbot.getAttribute('data-api-key'),
      apiUrl: chatbot.getAttribute('data-api-url') || 'https://api.openai.com/v1/chat/completions',
      model: chatbot.getAttribute('data-model') || 'gpt-3.5-turbo',
      context: chatbot.getAttribute('data-context') || '',
      // Storefront API configuratie
      storefrontApiToken: chatbot.getAttribute('data-storefront-api-token') || '',
      // RAG configuratie
      useRAG: true,
      maxChunksToInclude: 3,
      refreshCacheDaily: true
    };
    
    // Debug log voor instellingen
    console.log("Chatbot configuratie:", {
      apiKey: config.apiKey ? "Geconfigureerd" : "Ontbreekt",
      model: config.model,
      useRAG: config.useRAG,
      contextLength: config.context ? config.context.length : 0,
      storefrontApiToken: config.storefrontApiToken ? "Geconfigureerd" : "Ontbreekt"
    });
    
    // Kennisbankbestandspaden - Deze worden door Shopify verwerkt bij het renderen
    const kennisbankPaden = {
      merkinfo: `/assets/skinclarity_merkinformatie.md`,
      productkennis: `/assets/skinclarity_productkennisbestand.md`
    };
    
    // RAG Kennisdatabase structuur
    let knowledgeBase = {
      chunks: [],
      lastUpdated: null,
      isLoaded: false
    };
    
    // ===== STOREFRONT API FUNCTIES =====
    
    // Storefront API aanroepen om producten op te halen
    async function fetchProductsFromStorefront(query, limit = 3) {
      if (!config.storefrontApiToken) {
        console.error('Storefront API token ontbreekt');
        return [];
      }
      
      console.log(`Zoeken naar producten met query: "${query}"`);
      
      try {
        // Exacte product voorrang geven door directe match eerst te proberen
        let searchQuery = query;
        let priorityMatches = [];
        
        // Speciale gevallen waarbij een exacte productnaam een andere zoekquery nodig heeft
        const specialCaseMap = {
          // Sun Defense Minerals specifieke varianten
          'Sun Defense Minerals - Fair': 'Éminence Sun Defense Minerals Fair',
          'Sun Defense Minerals - Light': 'Éminence Sun Defense Minerals Light',
          'Sun Defense Minerals - Medium': 'Éminence Sun Defense Minerals Medium',
          'Sun Defense Minerals - Tan': 'Éminence Sun Defense Minerals Tan',
          'Sun Defense Minerals - Deep': 'Éminence Sun Defense Minerals Deep', 
          'Sun Defense Minerals - Sheer': 'Éminence Sun Defense Minerals Sheer',
          'Sun Defense Minerals': 'Éminence Sun Defense Minerals',
          
          // Overige producten
          'Stone Crop Whip Moisturizer': 'Éminence Stone Crop Whip',
          'Mangosteen Daily Resurfacing Cleanser': 'Éminence Mangosteen Daily Resurfacing',
          'Strawberry Rhubarb Masque': 'Éminence Strawberry Rhubarb Masque',
          'Eight Greens Phyto Masque HOT': 'Éminence Eight Greens Phyto',
          'Bakuchiol + Niacinamide Moisturizer': 'Éminence Bakuchiol',
          'Radiant Protection SPF Fluid': 'Éminence Radiant Protection',
          'Daily Defense Tinted SPF': 'Éminence Daily Defense',
          'Citrus & Kale Potent C+E Serum': 'Éminence Citrus Kale',
          'Yam & Pumpkin Peel 5%': 'Éminence Yam Pumpkin',
          
          // Nutrins producten
          'ProVen 50': 'Nutrins ProVen 50',
          'Proven 25': 'Nutrins Proven 25',
          'Liposomale Multivitamine': 'Nutrins Multivitamine',
          'Vitamine C': 'Nutrins Vitamine C',
          'Liposomale Glutathion': 'Nutrins Glutathion',
          'Liposomale FLM-X': 'Nutrins FLM',
          'BallastVezels': 'Nutrins Ballast',
          'Volledige Vezels': 'Nutrins Vezels',
          'Omega ADEK': 'Nutrins Omega',
          
          // Labrains producten
          'Rosa Cease Serum': 'Labrains Rosa Cease',
          'Cleansing Cream': 'Labrains Cleansing Cream',
          'Pore Perfect Cleanser': 'Labrains Pore Perfect',
          'Skin Perfecting Facial Peeling Mask': 'Labrains Peeling Mask',
          'Renovation Sculpter Cream': 'Labrains Renovation',
          'Renovation Sculptor Serum': 'Labrains Sculptor',
          'BB Cream': 'Labrains BB',
          'BB Cream - ultra light': 'Labrains BB ultra light',
          'BB Cream - light': 'Labrains BB light',
          'BB Cream - medium': 'Labrains BB medium',
          'Daily Face Cream voor Jonge Huid': 'Labrains Daily Face Cream'
        };
        
        // Controleer of we een speciale zoekquery moeten gebruiken
        if (specialCaseMap[query]) {
          searchQuery = specialCaseMap[query];
          console.log(`Speciale zoekquery gebruikt voor "${query}": "${searchQuery}"`);
        }
        
        // Definieer de GraphQL query - Aangepast om alleen beschikbare producten op te halen
        const graphqlQuery = `
          query ProductRecommendations($query: String!, $first: Int!) {
            search(query: $query, types: PRODUCT, first: $first) {
              edges {
                node {
                  ... on Product {
                    id
                    title
                    handle
                    vendor
                    productType
                    availableForSale
                    priceRange {
                      minVariantPrice {
                        amount
                        currencyCode
                      }
                    }
                    compareAtPriceRange {
                      minVariantPrice {
                        amount
                        currencyCode
                      }
                    }
                    images(first: 1) {
                      edges {
                        node {
                          url(transform: {maxWidth: 200, maxHeight: 200, crop: CENTER})
                          altText
                        }
                      }
                    }
                    variants(first: 5) {
                      edges {
                        node {
                          id
                          availableForSale
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `;
        
        // Bereid de request voor
        const response = await fetch(`${config.shopUrl}/api/2024-01/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': config.storefrontApiToken
          },
          body: JSON.stringify({
            query: graphqlQuery,
            variables: {
              query: searchQuery,
              first: limit * 2 // Haal meer producten op dan nodig, zodat we kunnen filteren op beschikbaarheid
            }
          })
        });
        
        if (!response.ok) {
          throw new Error(`Storefront API fout: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.errors) {
          console.error('GraphQL fouten:', data.errors);
          throw new Error('GraphQL fouten bij het ophalen van producten');
        }
        
        // Debug alle producten om te zien wat er terugkomt
        console.log('Alle opgehaalde producten:', data.data.search.edges.map(edge => ({
          title: edge.node.title,
          available: edge.node.availableForSale
        })));
        
        // Filter op producten die daadwerkelijk beschikbaar zijn
        const availableProducts = data.data.search.edges.filter(edge => {
          const product = edge.node;
          
          // Check op algemene product beschikbaarheid
          if (!product.availableForSale) {
            return false;
          }
          
          // Check of er ten minste één beschikbare variant is
          const hasAvailableVariant = product.variants.edges.some(variantEdge => 
            variantEdge.node.availableForSale
          );
          
          return hasAvailableVariant;
        });
        
        console.log(`Gefilterd op beschikbaarheid: ${availableProducts.length} van ${data.data.search.edges.length} producten beschikbaar`);
        
        // Controleer of de resultaten de exacte productnaam bevatten
        const titleContainsExactQuery = query.toLowerCase();
        
        // Prioriteit geven aan producten die de exacte query in de titel hebben
        const prioritizedProducts = availableProducts.sort((a, b) => {
          const titleA = a.node.title.toLowerCase();
          const titleB = b.node.title.toLowerCase();
          
          // Controleer welke titel meer overeenkomt met de oorspronkelijke query
          const aContainsQuery = titleA.includes(titleContainsExactQuery);
          const bContainsQuery = titleB.includes(titleContainsExactQuery);
          
          if (aContainsQuery && !bContainsQuery) return -1;
          if (!aContainsQuery && bContainsQuery) return 1;
          
          // Als beide (niet) overeenkomen, sorteer op volledig producttype
          const aIsComplete = a.node.productType.toLowerCase().includes('set') || 
                            titleA.includes('kit');
          const bIsComplete = b.node.productType.toLowerCase().includes('set') || 
                            titleB.includes('kit');
          
          if (!aIsComplete && bIsComplete) return -1;
          if (aIsComplete && !bIsComplete) return 1;
          
          return 0;
        });
        
        // Verwerk de beschikbare producten
        const products = prioritizedProducts.map(edge => {
          const product = edge.node;
          const imageUrl = product.images.edges.length > 0 
            ? product.images.edges[0].node.url 
            : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
          
          const price = parseFloat(product.priceRange.minVariantPrice.amount);
          const compareAtPrice = product.compareAtPriceRange.minVariantPrice.amount 
            ? parseFloat(product.compareAtPriceRange.minVariantPrice.amount) 
            : null;
          
          // Zoek de eerste beschikbare variant
          const availableVariant = product.variants.edges.find(variantEdge => 
            variantEdge.node.availableForSale
          );
          
          const variant = availableVariant ? availableVariant.node : null;
          
          return {
            id: product.id,
            title: product.title,
            handle: product.handle,
            vendor: product.vendor,
            productType: product.productType,
            price: price,
            compareAtPrice: compareAtPrice,
            image: imageUrl,
            imageAlt: product.images.edges.length > 0 ? product.images.edges[0].node.altText || product.title : product.title,
            variantId: variant ? variant.id : null,
            available: true, // We hebben al gefilterd op beschikbaarheid
            url: `${config.shopUrl}/products/${product.handle}`,
            originalQuery: query // Bijhouden van de oorspronkelijke query
          };
        });
        
        // Limit weer toepassen na filtering
        const limitedProducts = products.slice(0, limit);
        
        console.log(`${limitedProducts.length} beschikbare producten opgehaald via Storefront API`);
        console.log('Opgehaalde producten:', limitedProducts.map(p => p.title));
        
        // Als geen resultaten & we gebruikten een specifieke zoekterm, probeer een meer algemene
        if (limitedProducts.length === 0 && specialCaseMap[query]) {
          console.log(`Geen resultaten voor specifieke zoekterm, probeer algemene zoekterm: "${query}"`);
          // Probeer opnieuw zonder de speciale case mapping
          return fetchProductsFromStorefront(query.replace(/^(Éminence|Nutrins|Labrains|Mintenz)\s+/, ''), limit);
        }
        
        return limitedProducts;
      } catch (error) {
        console.error('Fout bij ophalen producten via Storefront API:', error);
        return [];
      }
    }
    
    // Toon aanbevolen producten
    function displayRecommendedProducts(products) {
      console.log(`Tonen van ${products.length} productaanbevelingen`);
      
      // Update de badge
      recommendationsBadge.textContent = products.length;
      recommendationsBadge.classList.toggle('hide', products.length === 0);
      
      // Voeg 'has-recommendations' class toe aan chatbot als er producten zijn
      chatbot.classList.toggle('has-recommendations', products.length > 0);
      
      // Leeg de container
      while (productsContent.firstChild) {
        productsContent.removeChild(productsContent.firstChild);
      }
      
      // Toon lege staat als er geen producten zijn
      if (products.length === 0) {
        const emptyEl = document.createElement('div');
        emptyEl.className = 'product-recommendations-empty';
        emptyEl.textContent = 'Geen aanbevelingen beschikbaar op dit moment.';
        productsContent.appendChild(emptyEl);
        productsContainer.classList.remove('has-products');
        return;
      }
      
      // Log of de chatbot panel open is voor debug
      console.log('Chatbot panel open?', chatbot.classList.contains('chatbot-open'));
      
      // Voeg 'has-products' class toe aan container
      productsContainer.classList.add('has-products');
      
      // Forceer productaanbevelingen om zichtbaar te zijn met inline stijlen
      if (chatbot.classList.contains('chatbot-open')) {
        productsContainer.style.display = 'flex';
        productsContainer.style.opacity = '1';
        productsContainer.style.visibility = 'visible';
        
        // Belangrijk: voorkom dat de container opnieuw verborgen wordt
        setTimeout(() => {
          if (chatbot.classList.contains('chatbot-open') && products.length > 0) {
            productsContainer.style.display = 'flex';
            productsContainer.style.opacity = '1';
            productsContainer.style.visibility = 'visible';
          }
        }, 500);
      }
      
      // Reset productaanbevelingen container stijl om hoogte-issues te verhelpen
      productsContent.style.maxHeight = `${Math.min(window.innerHeight * 0.6, 500)}px`;
      
      // Toon producten (maximaal 3)
      products.slice(0, 3).forEach(product => {
        // Creëer product item
        const productEl = document.createElement('a');
        productEl.className = 'product-recommendations-item';
        productEl.href = product.url;
        productEl.setAttribute('target', '_blank');
        
        // Formateer prijs
        const formattedPrice = new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: 'EUR'
        }).format(product.price);
        
        let formattedComparePrice = '';
        if (product.compareAtPrice && product.compareAtPrice > product.price) {
          formattedComparePrice = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: 'EUR'
          }).format(product.compareAtPrice);
        }
        
        // Zorg voor consistente leveranciersnaam die nooit undefined is
        const vendorName = product.vendor || '';
        
        // Vereenvoudigde productkaart layout voor betere weergave
        productEl.innerHTML = `
          <div class="product-image-container">
            <img class="product-image" src="${product.image}" alt="${product.imageAlt}" loading="lazy">
          </div>
          <div class="product-info">
            <div class="product-info-top">
              <div class="product-vendor">${vendorName}</div>
              <div class="product-title">${product.title}</div>
            </div>
            <div>
              <div class="product-price${product.compareAtPrice && product.compareAtPrice > product.price ? ' sale' : ''}" style="color: #D4AF37 !important; font-weight: 700 !important;">
                ${formattedPrice}
                ${formattedComparePrice ? `<span class="product-compare-price">${formattedComparePrice}</span>` : ''}
              </div>
              <button class="premium-add-to-cart" data-variant-id="${product.variantId}" ${!product.available ? 'disabled' : ''}>
                <span style="display: inline-flex; align-items: center;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg></span>
                <span>${product.available ? 'Aan winkelwagen toevoegen' : 'Uitverkocht'}</span>
              </button>
            </div>
          </div>
        `;
        
        // Voeg toe aan container
        productsContent.appendChild(productEl);
        
        // Voeg event listener toe voor winkelwagen knop
        const addToCartBtn = productEl.querySelector('.premium-add-to-cart');
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // e.stopPropagation(); - Verwijderd om de chatbot knop weer te laten werken
            
            // Voorkom bubbling naar de productkaart link door deze check
            if (e.target.closest('.premium-add-to-cart')) {
              // Als we echt op de knop hebben geklikt, voorkom navigatie maar laat andere events door
              e.stopImmediatePropagation(); // Stopt verdere handlers op hetzelfde element maar laat bubbling door
              
              if (this.disabled) return;
              
              const variantId = this.dataset.variantId;
              if (!variantId) {
                console.error('Geen variant ID gevonden voor deze knop:', this);
                return;
              }
              
              this.classList.add('loading');
              
              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: variantId,
                  quantity: 1
                })
              })
              .then(response => response.json())
              .then(data => {
                this.classList.remove('loading');
                this.classList.add('added');
                
                // Toon product toegevoegd notificatie
                showCartNotification('Product toegevoegd aan winkelwagen');
                
                setTimeout(() => {
                  this.classList.remove('added');
                }, 2000);
              })
              .catch(error => {
                console.error('Error:', error);
                this.classList.remove('loading');
              });
            }
          });
        }
      });
      
      console.log('Productaanbevelingen succesvol weergegeven');
      
      // Extra check om te garanderen dat producten zichtbaar zijn en correct geformatteerd
      if (chatbot.classList.contains('chatbot-open') && products.length > 0) {
        setTimeout(() => {
          console.log('Extra check zichtbaarheid productaanbevelingen');
          productsContainer.style.display = 'flex';
          productsContainer.style.opacity = '1';
          productsContainer.style.visibility = 'visible';
          
          // Zorg voor correcte scrolling in de productcontainer
          productsContent.scrollTop = 0;
          
          // Controleer of alle producten volledig zichtbaar zijn
          const productItems = productsContent.querySelectorAll('.product-recommendations-item');
          productItems.forEach(item => {
            item.style.display = 'flex';
            item.style.visibility = 'visible';
          });
        }, 1000);
      }
    }
    
    // Functie om notificatie weer te geven voor winkelwagen
    function showCartNotification(message, type = 'default') {
      // Controleer of er een bestaande notificatie is
      let notification = document.querySelector('.premium-cart-notification');
      
      if (!notification) {
        notification = document.createElement('div');
        notification.className = 'premium-cart-notification';
        notification.id = 'premium-cart-notification';
        
        const notificationContent = document.createElement('div');
        notificationContent.className = 'premium-cart-notification-content';
        
        const icon = document.createElement('div');
        icon.className = 'premium-cart-notification-icon';
        icon.innerHTML = '<i class="fa fa-check-circle"></i>';
        
        const messageElement = document.createElement('div');
        messageElement.className = 'cart-notification-message';
        
        notificationContent.appendChild(icon);
        notificationContent.appendChild(messageElement);
        notification.appendChild(notificationContent);
        
        // Basis styling voor de notificatie
        notification.style.position = 'fixed';
        notification.style.bottom = '20px';
        notification.style.right = '20px';
        notification.style.zIndex = '9999';
        notification.style.backgroundColor = 'white';
        notification.style.borderRadius = '8px';
        notification.style.boxShadow = '0 5px 15px rgba(0,0,0,0.15)';
        notification.style.overflow = 'hidden';
        notification.style.transform = 'translateY(100px)';
        notification.style.opacity = '0';
        notification.style.transition = 'all 0.3s ease';
        notification.style.width = 'auto';
        notification.style.maxWidth = '320px';
        
        // Styling voor de inhoud
        notificationContent.style.display = 'flex';
        notificationContent.style.alignItems = 'center';
        notificationContent.style.padding = '15px';
        
        // Styling voor het icoon
        icon.style.backgroundColor = '#D4AF37';
        icon.style.color = 'white';
        icon.style.width = '36px';
        icon.style.height = '36px';
        icon.style.borderRadius = '50%';
        icon.style.display = 'flex';
        icon.style.alignItems = 'center';
        icon.style.justifyContent = 'center';
        icon.style.marginRight = '12px';
        icon.style.fontSize = '18px';
        
        document.body.appendChild(notification);
      }
      
      // Update bericht
      const messageElement = notification.querySelector('.cart-notification-message');
      messageElement.textContent = message;
      messageElement.style.fontSize = '14px';
      messageElement.style.fontWeight = '500';
      
      // Toon notificatie met animatie
      notification.style.display = 'block';
      
      // Forceer een reflow
      void notification.offsetWidth;
      
      // Animeer in
      notification.style.transform = 'translateY(0)';
      notification.style.opacity = '1';
      
      // Verberg na 3 seconden
      setTimeout(() => {
        notification.style.transform = 'translateY(100px)';
        notification.style.opacity = '0';
        
        setTimeout(() => {
          notification.style.display = 'none';
        }, 300);
      }, 3000);
    }
    
    // Analyseer bericht om potentiële zoekbegrippen voor producten te vinden
    function extractProductSearchTerms(text) {
      // Eenvoudige logica om te zien of het bericht gerelateerd is aan producten
      const productIndicators = [
        'product', 'producten', 'kopen', 'aanraden', 'aanbevelen', 'aanbeveling', 
        'bestseller', 'populair', 'verkoop', 'prijs', 'serum', 'crème', 'creme', 
        'hydrateren', 'hydraterende', 'voor mijn huid', 'huidtype', 'droge huid', 
        'vette huid', 'gevoelige huid', 'toner', 'cleanser', 'reiniging', 'masker', 
        'peeling', 'anti-aging', 'anti-rimpel', 'zonnebrand', 'sunscreen',
        'advies', 'wat raad je aan', 'wat zou jij', 'verkopen jullie', 'hebben jullie',
        'wat kost', 'prijs van', 'prijzen', 'wat is', 'welke', 'aanbeveling',
        'moisturizer', 'lotion', 'waar kan ik', 'bestellen'
      ];
      
      // Lijst met termen die juist NIET over producten gaan
      const nonProductIndicators = [
        'retour', 'retourneren', 'terugsturen', 'teruggave', 'verzendkosten', 
        'verzending', 'levertijd', 'bezorging', 'levering', 'betalen', 'betaling',
        'factuur', 'garantie', 'klacht', 'bestelling annuleren', 'annuleren',
        'contact', 'klantenservice', 'telefoon', 'email', 'e-mail', 'mail',
        'openingstijden', 'adres', 'winkel', 'locatie', 'route', 'betalingsmethoden'
      ];

      // Controleer eerst of het bericht over niet-product onderwerpen gaat
      const lowerText = text.toLowerCase();
      const isNonProductQuery = nonProductIndicators.some(term => lowerText.includes(term));
      
      // Als het duidelijk over een niet-product onderwerp gaat, retourneer null
      if (isNonProductQuery) {
        console.log('Bericht gaat over niet-product onderwerp, geen productaanbevelingen tonen');
        return null;
      }
      
      // Controleer of het bericht vraagt naar producten
      const isProductQuery = productIndicators.some(term => lowerText.includes(term));
      
      // Lijst met EXACTE productnamen uit de webshop kennisbank
      const actualProducts = [
        // Éminence Organic Skincare producten - Sun Defense Minerals varianten
        { regex: /sun\s+defense\s+minerals\s+[\-\–]\s*fair/i, term: 'Sun Defense Minerals - Fair' },
        { regex: /sun\s+defense\s+minerals\s+[\-\–]\s*light/i, term: 'Sun Defense Minerals - Light' },
        { regex: /sun\s+defense\s+minerals\s+[\-\–]\s*medium/i, term: 'Sun Defense Minerals - Medium' },
        { regex: /sun\s+defense\s+minerals\s+[\-\–]\s*tan/i, term: 'Sun Defense Minerals - Tan' },
        { regex: /sun\s+defense\s+minerals\s+[\-\–]\s*deep/i, term: 'Sun Defense Minerals - Deep' },
        { regex: /sun\s+defense\s+minerals\s+[\-\–]\s*sheer/i, term: 'Sun Defense Minerals - Sheer' },
        { regex: /sun\s+defense\s+minerals(?!\s+[\-\–])/i, term: 'Sun Defense Minerals' }, // Match zonder variant
        
        // Éminence Organic Skincare producten - overig
        { regex: /stone\s+crop\s+whip\s+moisturizer/i, term: 'Stone Crop Whip Moisturizer' },
        { regex: /mangosteen\s+daily\s+resurfacing\s+cleanser/i, term: 'Mangosteen Daily Resurfacing Cleanser' },
        { regex: /turmeric\s+energizing\s+treatment/i, term: 'Turmeric Energizing Treatment' },
        { regex: /strawberry\s+rhubarb\s+masque/i, term: 'Strawberry Rhubarb Masque' },
        { regex: /strawberry\s+rhubarb\s+hyaluronic\s+hydrator/i, term: 'Strawberry Rhubarb Hyaluronic Hydrator' },
        { regex: /eight\s+greens\s+phyto\s+masque\s+hot/i, term: 'Eight Greens Phyto Masque HOT' },
        { regex: /bakuchiol\s+\+\s+niacinamide\s+moisturizer/i, term: 'Bakuchiol + Niacinamide Moisturizer' },
        { regex: /radiant\s+protection\s+spf\s+fluid/i, term: 'Radiant Protection SPF Fluid' },
        { regex: /daily\s+defense\s+tinted\s+spf/i, term: 'Daily Defense Tinted SPF' },
        { regex: /citrus\s+&?\s+kale\s+potent\s+c\+e\s+serum/i, term: 'Citrus & Kale Potent C+E Serum' },
        { regex: /yam\s+&?\s+pumpkin\s+peel\s+5%/i, term: 'Yam & Pumpkin Peel 5%' },
        { regex: /[ée]minence\s+organic/i, term: 'Éminence Organic Skincare producten' },
        
        // Nutrins producten
        { regex: /liposomale\s+multivitamine/i, term: 'Liposomale Multivitamine' },
        { regex: /proven\s+25/i, term: 'Proven 25' },
        { regex: /proven\s+50/i, term: 'ProVen 50' },
        { regex: /vitamine\s+c/i, term: 'Vitamine C' },
        { regex: /liposomale\s+glutathion/i, term: 'Liposomale Glutathion' },
        { regex: /liposomale\s+flm-x/i, term: 'Liposomale FLM-X' },
        { regex: /ballast\s*vezels/i, term: 'BallastVezels' },
        { regex: /omega\s+adek/i, term: 'Omega ADEK' },
        { regex: /volledige\s+vezels/i, term: 'Volledige Vezels' },
        
        // Labrains producten - BB Cream varianten
        { regex: /bb\s+cream\s+[\-\–]\s*ultra\s+light/i, term: 'BB Cream - ultra light' },
        { regex: /bb\s+cream\s+[\-\–]\s*light/i, term: 'BB Cream - light' },
        { regex: /bb\s+cream\s+[\-\–]\s*medium/i, term: 'BB Cream - medium' },
        { regex: /bb\s+cream(?!\s+[\-\–])/i, term: 'BB Cream' }, // Match zonder variant
        
        // Labrains producten - overig
        { regex: /cleansing\s+cream/i, term: 'Cleansing Cream' },
        { regex: /pore\s+perfect\s+cleanser/i, term: 'Pore Perfect Cleanser' },
        { regex: /daily\s+face\s+cream\s+voor\s+jonge\s+huid/i, term: 'Daily Face Cream voor Jonge Huid' },
        { regex: /rosa\s+cease\s+serum/i, term: 'Rosa Cease Serum' },
        { regex: /renovation\s+sculpter\s+cream/i, term: 'Renovation Sculpter Cream' },
        { regex: /renovation\s+sculptor\s+serum/i, term: 'Renovation Sculptor Serum' },
        { regex: /skin\s+perfecting\s+facial\s+peeling\s+mask/i, term: 'Skin Perfecting Facial Peeling Mask' },
        { regex: /pore\s+perfect\s+serum/i, term: 'Pore Perfect Serum' },
        { regex: /rosa\s+cease\s+and\s+pore\s+perfect\s+cream/i, term: 'Rosa Cease And Pore Perfect Cream' },
        
        // Mintenz producten
        { regex: /501\s+concealer\s+kwast/i, term: '501 Concealer kwast' },
        { regex: /506\s+small\s+pointed\s+brush/i, term: '506 Small pointed brush' },
        { regex: /509\s+schuine\s+kwast\s+small/i, term: '509 Schuine kwast small' },
        { regex: /kabuki\s+long\s+foundation\s+(zwart|silver)/i, term: 'Kabuki Long Foundation' },
        { regex: /mini\s+kabuki\s+foundation/i, term: 'Mini Kabuki Foundation' },
        { regex: /primer/i, term: 'Primer' },
        { regex: /highlighter/i, term: 'Highlighter' },
        { regex: /bronzer/i, term: 'Bronzer' },
        { regex: /finisher/i, term: 'Finisher' },
        { regex: /blusher/i, term: 'Blusher' },
        { regex: /foundation/i, term: 'Foundation' }
      ];
      
      // Zoek eerst naar exacte productnamen in het bericht
      for (const product of actualProducts) {
        if (product.regex.test(text)) {
          console.log(`Exact product herkend: ${product.term}`);
          return product.term;
        }
      }
      
      // Als geen exact product, kijk of het een algemene productvraag is
      if (!isProductQuery) {
        return null;
      }
      
      // Categoriseer op basis van huidtype/producttype
      let searchTerm = '';
      
      // Duidelijke else-if structuur zodat slechts één conditie kan matchen
      if (lowerText.includes('droge huid')) {
        searchTerm = 'hydraterende verzorging droge huid';
      } else if (lowerText.includes('vette huid')) {
        searchTerm = 'verzorging vette huid';
      } else if (lowerText.includes('gevoelige huid')) {
        searchTerm = 'verzorging gevoelige huid';
      } else if (lowerText.includes('anti-aging') || lowerText.includes('anti-rimpel') || lowerText.includes('rimpels')) {
        searchTerm = 'anti-aging verzorging';
      } else if (lowerText.includes('serum')) {
        searchTerm = 'gezichtsserum';
      } else if (lowerText.includes('reinig') || lowerText.includes('cleanser')) {
        searchTerm = 'gezichtsreiniging';
      } else if (lowerText.includes('zonnebrand') || lowerText.includes('sunscreen') || lowerText.includes('uv')) {
        searchTerm = 'zonnebescherming';
      } else if (lowerText.includes('bestseller') || lowerText.includes('populair')) {
        searchTerm = 'bestsellers';
      } else if (lowerText.includes('hydrateren') || lowerText.includes('hydraterende')) {
        searchTerm = 'hydraterende gezichtsverzorging';
      } else if (lowerText.includes('toner') || lowerText.includes('lotion')) {
        searchTerm = 'gezichtstoner';
      } else if (lowerText.includes('masker') || lowerText.includes('sheet mask')) {
        searchTerm = 'gezichtsmasker';
      } else if (lowerText.includes('moisturizer')) {
        searchTerm = 'moisturizer';
      } else {
        // Als geen specifiek patroon, kijk naar opvallende product-gerelateerde termen
        // We geven prioriteit aan termen die vaak in productnamen voorkomen
        const productTerms = [
          'serum', 'moisturizer', 'cream', 'creme', 'crème', 'lotion', 'toner', 
          'cleanser', 'scrub', 'peeling', 'masker', 'oil', 'olie'
        ];
        
        // Zoek naar woorden die overeenkomen met producttermen
        for (const term of productTerms) {
          if (lowerText.includes(term)) {
            // Haal een deel van de zin op rond het woord voor context
            const words = lowerText.split(' ');
            const termIndex = words.findIndex(word => word.includes(term));
            if (termIndex !== -1) {
              // Neem tot 3 woorden voor en na de term
              const start = Math.max(0, termIndex - 3);
              const end = Math.min(words.length, termIndex + 4);
              searchTerm = words.slice(start, end).join(' ');
              console.log(`Gevonden productterm "${term}" in context: "${searchTerm}"`);
              break;
            }
          }
        }
        
        // Als nog steeds geen zoekterm, gebruik hele zin (max 5 woorden)
        if (!searchTerm) {
          const words = text.split(/\s+/).filter(word => word.length > 3);
          searchTerm = words.slice(0, 5).join(' ');
        }
      }
      
      console.log(`Geëxtraheerde zoekterm: "${searchTerm}"`);
      return searchTerm || 'huidverzorging'; // Fallback
    }
    
    // ===== RAG-FUNCTIES =====
    
    // Initialiseer en laad kennisbank
    async function initializeKnowledgeBase() {
      try {
        console.log("Starten met laden van kennisbank...");
        
        // Als we al context hebben vanuit de instellingen, gebruik die direct
        if (config.context && config.context.length > 0) {
          console.log("Gebruik vooraf geconfigureerde context vanuit instellingen");
          knowledgeBase.chunks = [{
            id: 'context-1',
            type: 'configuratie-context',
            content: config.context,
            keywords: extractKeywords(config.context)
          }];
          knowledgeBase.lastUpdated = new Date();
          knowledgeBase.isLoaded = true;
          console.log("Kennisbank geladen vanuit configuratie context");
          return true;
        }
        
        // Controleer of we de kennisbank moeten verversen
        const shouldRefresh = !knowledgeBase.lastUpdated || 
                         (config.refreshCacheDaily && isNewDay(knowledgeBase.lastUpdated));
        
        if (shouldRefresh || !knowledgeBase.isLoaded) {
          console.log("Start met ophalen van kennisbestanden...");
          
          // Test eerst de beschikbaarheid van de bestanden
          const merkinfoAvailable = await isFileAvailable(kennisbankPaden.merkinfo);
          const productAvailable = await isFileAvailable(kennisbankPaden.productkennis);
          
          console.log("Bestandsbeschikbaarheid:", {
            merkinfo: merkinfoAvailable,
            productkennis: productAvailable
          });
          
          // Verzamel alle beschikbare bestanden
          let allChunks = [];
          
          // Haal alleen beschikbare bestanden op
          if (merkinfoAvailable) {
            const merkinfoChunks = await fetchAndProcessMarkdownFile(kennisbankPaden.merkinfo);
            if (merkinfoChunks.length > 0) {
              allChunks = [...allChunks, ...merkinfoChunks.map(chunk => ({...chunk, type: 'merkinformatie'}))];
              console.log(`Merkinfo geladen: ${merkinfoChunks.length} chunks`);
            }
          }
          
          if (productAvailable) {
            const productChunks = await fetchAndProcessMarkdownFile(kennisbankPaden.productkennis);
            if (productChunks.length > 0) {
              allChunks = [...allChunks, ...productChunks.map(chunk => ({...chunk, type: 'productkennis'}))];
              console.log(`Productkennis geladen: ${productChunks.length} chunks`);
            }
          }
          
          // Als we tenminste één bestand hebben kunnen laden, update kennisbank
          if (allChunks.length > 0) {
            knowledgeBase.chunks = allChunks;
            knowledgeBase.lastUpdated = new Date();
            knowledgeBase.isLoaded = true;
            console.log(`RAG Kennisdatabase geïnitialiseerd met ${knowledgeBase.chunks.length} chunks`);
            return true;
          } else {
            // Als niets geladen kon worden, ga naar fallback
            console.warn("Geen kennisbestanden konden worden geladen, initialiseren van fallback");
            return initializeDummyKnowledgeBase();
          }
        }
        
        return knowledgeBase.isLoaded;
      } catch (error) {
        console.error('Fout bij initialiseren kennisdatabase:', error);
        // Fallback naar dummy data als het laden mislukt
        return initializeDummyKnowledgeBase();
      }
    }
    
    // Controleer of een bestand beschikbaar is voordat we het proberen te laden
    async function isFileAvailable(filePath) {
      try {
        // Maak pad relatief en voeg timestamp toe
        let url = filePath;
        if (url.startsWith(config.shopUrl)) {
          url = url.replace(config.shopUrl, '');
        }
        url = `${url}?t=${Date.now()}`;
        
        // Gebruik HEAD request om alleen headers te controleren
        const response = await fetch(url, {
          method: 'HEAD',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });
        
        return response.ok;
      } catch (error) {
        console.warn(`Bestand niet beschikbaar: ${filePath}`, error);
        return false;
      }
    }
    
    // Dummy kennisdatabase voor testen en fallback
    function initializeDummyKnowledgeBase() {
      console.log("Initialiseren van dummy kennisdatabase als fallback");
      knowledgeBase.chunks = [
        {
          id: 'merk-1',
          type: 'merkinformatie',
          content: 'SkinClarity Club is een Nederlands luxe huidverzorgingsmerk opgericht in 2018. Onze visie is huidverzorging op maat, gebaseerd op wetenschappelijk onderzoek en natuurlijke ingrediënten.',
          keywords: ['skinclarity', 'merk', 'huidverzorging', 'nederlands', 'luxe', 'wetenschappelijk', 'natuurlijk']
        },
        {
          id: 'product-1',
          type: 'productkennis',
          content: 'Vitamine C Serum: Ons bestverkochte serum met 15% stabiele vitamine C. Ideaal voor het verminderen van pigmentvlekken en het verhelderen van de teint. Bevat ook vitamine E en ferulinezuur voor extra antioxidantbescherming.',
          keywords: ['vitamine c', 'serum', 'pigmentvlekken', 'verhelderen', 'teint', 'antioxidant']
        }
      ];
      
      knowledgeBase.lastUpdated = new Date();
      knowledgeBase.isLoaded = true;
      
      console.log('Dummy kennisdatabase geïnitialiseerd met', knowledgeBase.chunks.length, 'chunks');
      return true;
    }
    
    // Controleer of het een nieuwe dag is voor cache refresh
    function isNewDay(lastDate) {
      if (!lastDate) return true;
      
      const now = new Date();
      return lastDate.getDate() !== now.getDate() || 
             lastDate.getMonth() !== now.getMonth() || 
             lastDate.getFullYear() !== now.getFullYear();
    }
    
    // Verbeterde fetch-functie met robuuste foutafhandeling
    async function fetchAndProcessMarkdownFile(filePath) {
      try {
        console.log(`Ophalen van bestand: ${filePath}`);
        
        // Controleer of de URL geldig is
        if (!filePath || filePath.includes('null') || filePath.includes('undefined')) {
          console.error(`Ongeldig bestandspad: ${filePath}`);
          return [];
        }
        
        // Maak pad relatief en voeg timestamp toe
        let url = filePath;
        if (url.startsWith(config.shopUrl)) {
          url = url.replace(config.shopUrl, '');
        }
        url = `${url}?t=${Date.now()}`;
        
        // Haal bestand op met cache-preventie
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          },
          cache: 'no-store'
        });
        
        if (!response.ok) {
          console.error(`Bestand kon niet worden geladen: ${url}, status: ${response.status}`);
          
          // Probeer alternatief pad als het een asset is
          if (url.includes('/assets/')) {
            const assetName = url.split('/assets/')[1].split('?')[0];
            const altUrl = `/assets/${assetName}?t=${Date.now()}`;
            
            console.log(`Probeer alternatief pad: ${altUrl}`);
            const altResponse = await fetch(altUrl, {
              method: 'GET',
              headers: { 'Cache-Control': 'no-cache' }
            });
            
            if (!altResponse.ok) {
              throw new Error(`Bestand kon niet worden geladen via beide paden`);
            }
            
            const text = await altResponse.text();
            return processMarkdownToChunks(text, altUrl);
          }
          
          throw new Error(`Bestand kon niet worden geladen: ${url}`);
        }
        
        const markdownText = await response.text();
        console.log(`Bestand succesvol geladen: ${url}, ${markdownText.length} bytes`);
        
        // Valideer dat we markdown hebben ontvangen, niet HTML
        if (markdownText.includes('<!DOCTYPE html>') || markdownText.includes('<html')) {
          console.error('Ontvangen bestand is HTML, geen markdown');
          return [];
        }
        
        // Verwerk markdown naar chunks
        return processMarkdownToChunks(markdownText, url);
      } catch (error) {
        console.error(`Fout bij laden van bestand ${filePath}:`, error);
        return [];
      }
    }
    
    // Verwerk markdown-tekst naar chunks voor de kennisbank
    function processMarkdownToChunks(markdownText, source) {
      if (!markdownText || markdownText.trim().length === 0) {
        return [];
      }
      
      console.log(`Verwerken van markdown bestand: ${source}`);
      
      const chunks = [];
      let chunkId = 1;
      
      // Bepaal bestandsnaam en type
      const fileName = source.split('/').pop().split('?')[0] || 'unknown';
      const fileBase = fileName.replace(/\.\w+$/, '');
      
      // Verbeterde regels voor secties splitsen (headers + dividers)
      const sections = markdownText.split(/^(#{1,3} .*|---.*)/m);
      let currentSection = '';
      
      // Verwerk secties
      for (let i = 0; i < sections.length; i++) {
        const section = sections[i].trim();
        if (!section) continue;
        
        // Als dit een header of divider is, start een nieuwe sectie
        if (section.match(/^(#{1,3} |---)/)) {
          // Verwerk vorige sectie als die bestaat
          if (currentSection) {
            const id = `${fileBase}-${chunkId++}`;
            const keywords = extractKeywords(currentSection);
            chunks.push({
              id,
              content: currentSection.trim(),
              keywords,
              source: fileName
            });
          }
          // Begin nieuwe sectie met deze header
          currentSection = section;
        } else {
          // Voeg toe aan huidige sectie
          currentSection += '\n\n' + section;
        }
      }
      
      // Verwerk laatste sectie als die bestaat
      if (currentSection) {
        const id = `${fileBase}-${chunkId++}`;
        const keywords = extractKeywords(currentSection);
        chunks.push({
          id,
          content: currentSection.trim(),
          keywords,
          source: fileName
        });
      }
      
      console.log(`Verwerkt bestand ${fileName}: ${chunks.length} chunks gecreëerd`);
      return chunks;
    }
    
    // Extraheer keywords uit tekst voor betere zoekresultaten
    function extractKeywords(text) {
      // Eenvoudige implementatie: extraheer meest voorkomende woorden
      const words = text.toLowerCase()
                     .replace(/[^\w\sÀ-ÿ]/g, '') // Support voor Nederlandse tekens
                     .split(/\s+/)
                     .filter(word => word.length > 3); // Filter korte woorden
      
      // Tel woord frequencies
      const wordCounts = {};
      words.forEach(word => {
        wordCounts[word] = (wordCounts[word] || 0) + 1;
      });
      
      // Sorteer op frequentie en neem top 10
      return Object.entries(wordCounts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10)
        .map(entry => entry[0]);
    }
    
    // Zoek relevante chunks voor een query
    function findRelevantChunks(userQuery, maxChunks = 3) {
      if (!knowledgeBase.isLoaded || knowledgeBase.chunks.length === 0) {
        console.warn('Kennisbank niet geladen, geen chunks gevonden');
        return [];
      }
      
      // Verwerk query naar zoektermen
      const queryTerms = userQuery.toLowerCase()
        .replace(/[^\w\s\u00C0-\u017FÀ-ÿ]/g, ' ') // Behoud letters, cijfers, spaties en accenten
        .split(/\s+/)
        .filter(term => term.length > 2); // Filter korte woorden
      
      if (queryTerms.length === 0) return [];
      
      // Scoor elk chunk op relevantie
      const scoredChunks = knowledgeBase.chunks.map(chunk => {
        const content = chunk.content.toLowerCase();
        let score = 0;
        
        // Basisscoring: term komt voor in content
        queryTerms.forEach(term => {
          if (content.includes(term)) {
            score += 1;
            // Bonus als term voorkomt in eerste 100 tekens (waarschijnlijk belangrijker)
            if (content.substring(0, 100).includes(term)) {
              score += 0.5;
            }
          }
        });
        
        // Bonus voor keyword matches
        if (chunk.keywords && Array.isArray(chunk.keywords)) {
          queryTerms.forEach(term => {
            if (chunk.keywords.includes(term)) {
              score += 1.5;
            } else if (chunk.keywords.some(keyword => keyword.includes(term) || term.includes(keyword))) {
              score += 0.8;
            }
          });
        }
        
        return { ...chunk, score };
      });
      
      // Filter, sorteer en limiteer chunks
      const relevantChunks = scoredChunks
        .filter(chunk => chunk.score > 0)
        .sort((a, b) => b.score - a.score)
        .slice(0, maxChunks);
      
      console.log(`Gevonden ${relevantChunks.length} relevante chunks van ${knowledgeBase.chunks.length} totaal`);
      return relevantChunks;
    }
    
    // ===== OPENAI API FUNCTIES =====
    
    // Systeem prompt voor de chatbot
    const SYSTEM_PROMPT = `Je bent de SkinClarity Club AI-expert: een vriendelijke, toegankelijke en professionele skincare-specialist die álle producten, ingrediënten en routines kent van de merken LABRAINS, Éminence Organics, Éminence Sun Defence, Mintenz en Nutrins.

Je helpt bezoekers van de webshop skinclarityclub.nl met persoonlijk productadvies op basis van huidtype, huidproblemen (zoals acne, pigmentvlekken, gevoeligheid, roodheid), levensstijl en voorkeuren. Je stelt altijd eerst gerichte vragen zoals:

- Wat is je huidtype? (droog, vet, gemengd, gevoelig)
- Heb je ergens last van, zoals acne of pigmentvlekken?
- Zoek je een product voor de ochtend, avond of beide?

Je kent ingrediënten (zoals niacinamide, retinol, probiotica, fruitenzymen, zink, etc.) en weet voor wie ze geschikt zijn. Je kunt maximaal 3 producten tegelijk adviseren en geeft duidelijke uitleg over werking en gebruik.

Je mag ook vragen beantwoorden over:
- Het SkinClarity Program® en de SkinClarity Academy
- Verzending, retour en veelgestelde vragen
- Vegan of zwangerschapsveilige producten
- De natuurlijke make-up van Mintenz
- Supplementen van Nutrins voor huidverbetering van binnenuit

Toonstijl:
- Vriendelijk, sociaal, geruststellend
- Professioneel en duidelijk
- Gebruik "je" in plaats van "u"
- Sluit gesprekken af met een logische vervolgstap of vraag (bijv. "Zal ik ook een SPF voor je opzoeken?")

Richtlijnen:
- BELANGRIJK: Raad ALLEEN producten aan die DAADWERKELIJK in ons assortiment zitten.
- BELANGRIJK: Structureer je antwoorden ALTIJD op een compacte, luxueuze manier.
- Gebruik emoji's strategisch om je tekst visueel in te delen (niet overmatig).
- Gebruik vetgedrukte productnamen en korte, krachtige beschrijvingen.
- Houd je antwoorden beknopt, zakelijk en premium.
- Bij vragen over niet-product onderwerpen (zoals retourbeleid) geef alleen de gevraagde informatie.

Voor huidverzorgingsroutines, gebruik ALTIJD deze meer compacte format:

🌞 **OCHTENDROUTINE**
• **[Productnaam]** - [Merk] €XX,XX
  → Korte beschrijving in max. 1 zin. *Gebruik: in 1 korte zin*

• **[Productnaam]** - [Merk] €XX,XX 
  → Korte beschrijving in max. 1 zin. *Gebruik: in 1 korte zin*

🌙 **AVONDROUTINE**
• **[Productnaam]** - [Merk] €XX,XX
  → Korte beschrijving in max. 1 zin. *Gebruik: in 1 korte zin*

• **[Productnaam]** - [Merk] €XX,XX
  → Korte beschrijving in max. 1 zin. *Gebruik: in 1 korte zin*

Verzin GEEN productnamen die niet in onze lijst staan.
Noem altijd de volledige productnamen met percentages indien vermeld.
BELANGRIJK: Als je Sun Defense Minerals of BB Cream aanbeveelt, specificeer ALTIJD welke variant het beste past bij de huidtint van de klant.
Bij vragen over specifieke huidcondities, koppel deze aan relevante producten.`;
    
    // Roep OpenAI API aan met relevante context
    async function callOpenAIWithContext(userMessage, relevantChunks) {
      try {
        // Bereid context voor uit relevante chunks
        let contextText = '';
        
        if (relevantChunks.length > 0) {
          // Groepeer chunks per type voor betere structuur
          const merkinfoChunks = relevantChunks.filter(chunk => chunk.type === 'merkinformatie');
          const productChunks = relevantChunks.filter(chunk => chunk.type === 'productkennis');
          const configChunks = relevantChunks.filter(chunk => chunk.type === 'configuratie-context');
          
          if (configChunks.length > 0) {
            contextText += configChunks.map(chunk => chunk.content).join("\n\n") + "\n\n";
          }
          
          if (merkinfoChunks.length > 0) {
            contextText += "## Merkinformatie:\n" + merkinfoChunks.map(chunk => chunk.content).join("\n\n") + "\n\n";
          }
          
          if (productChunks.length > 0) {
            contextText += "## Productinformatie:\n" + productChunks.map(chunk => chunk.content).join("\n\n") + "\n\n";
          }
        }
        
        // Voeg beschikbare producten toe aan context
        contextText += `
## Beschikbare Producten:
Hieronder staan alle beschikbare producten in ons assortiment. Verwijs ALLEEN naar deze producten:

Éminence Organic Skincare producten:
- Sun Defense Minerals - Beschikbaar in 6 kleurtinten:
  * Sun Defense Minerals - Fair: Voor lichte huid met rozige ondertoon
  * Sun Defense Minerals - Light: Voor lichte tot medium huid met beige ondertoon
  * Sun Defense Minerals - Medium: Voor medium tot olijfkleurige huid met warme beige ondertoon
  * Sun Defense Minerals - Tan: Voor medium tot diepe huid met goudbruine ondertoon
  * Sun Defense Minerals - Deep: Voor diepe tot donkere huid met rijke gouden ondertoon
  * Sun Defense Minerals - Sheer: Transparant zonder kleurdekking voor alle huidtypen
- Stone Crop Whip Moisturizer - Hydraterende en verzachtende crème voor alle huidtypen.
- Mangosteen Daily Resurfacing Cleanser - Verzachtende reiniger die de huid vernieuwt.
- Turmeric Energizing Treatment - Stimulerende behandeling met kurkuma.
- Strawberry Rhubarb Masque - Verfrissend masker met aardbei en rabarber.
- Strawberry Rhubarb Hyaluronic Hydrator - Hydraterende gel-crème met hyaluronzuur.
- Eight Greens Phyto Masque HOT - Verwarmend masker rijk aan fyto-oestrogenen.
- Bakuchiol + Niacinamide Moisturizer - Anti-aging moisturizer met retinol-alternatief.
- Radiant Protection SPF Fluid - Beschermende SPF met stralende finish.
- Daily Defense Tinted SPF - Getinte SPF voor dagelijkse bescherming.
- Citrus & Kale Potent C+E Serum - Antioxidant serum met vitamine C en E.
- Yam & Pumpkin Peel 5% - Enzymatische peeling met 5% concentratie.

Nutrins producten:
- Liposomale Multivitamine - Vloeibare multivitaminen in liposomen.
- Proven 25 - Probiotica met Acidophilus en Bifidum.
- ProVen 50 - Hoog gedoseerde probiotica, geschikt tijdens antibiotica.
- Vitamine C - Liposomale vitamine C voor optimale opname.
- Liposomale Glutathion - Antioxidant voor ontgiftingsprocessen.
- Liposomale FLM-X - Bevat vitamine C met curcuma, rutine en quercetine.
- BallastVezels - Voedingssupplement met lijnzaadmeel.
- Omega ADEK - Premium kwaliteit omega-3-olie met vetoplosbare vitaminen.
- Volledige Vezels - Vezelrijke supplement met verschillende oplosbare vezels.

Labrains producten:
- Cleansing Cream - Romige cleanser die het microbioom beschermt.
- Pore Perfect Cleanser - Gezichtsreiniger voor verfijnde poriën.
- Daily Face Cream voor Jonge Huid - Dagcrème speciaal voor jonge huid.
- BB Cream - Getinte dagcrème met UV-bescherming in drie varianten:
  * BB Cream - ultra light: Voor zeer lichte huid met koele ondertoon
  * BB Cream - light: Voor lichte tot medium huid met warme ondertoon
  * BB Cream - medium: Voor medium huid met olijf ondertoon
- Rosa Cease Serum - Serum tegen roodheid en rosacea.
- Renovation Sculpter Cream - Anti-aging dagcrème met liftend effect.
- Renovation Sculptor Serum - Hydraterend serum met anti-aging eigenschappen.
- Skin Perfecting Facial Peeling Mask - Peeling masker voor huidvernieuwing.
- Pore Perfect Serum - Serum voor de gevoelige en acnegevoelige huid.
- Rosa Cease And Pore Perfect Cream - Crème tegen roodheid en ontstekingen.

Mintenz producten:
- 501 Concealer kwast - Kwast voor het aanbrengen van concealer.
- 506 Small pointed brush - Precieze kwast voor gedetailleerd werk.
- 509 Schuine kwast small - Kleine kwast voor blush of highlighter.
- Kabuki Long Foundation - Foundation kwast met verlengd handvat (Zwart of Silver).
- Mini Kabuki Foundation - Compacte foundation kwast, ideaal voor onderweg.
- Primer - Minerale primer voor matterend effect.
- Highlighter - Minerale highlighter voor een natuurlijke glans.
- Bronzer - Minerale bronzer in verschillende tinten.
- Finisher - Lichte, zijdezachte minerale poeder als finishing touch.
- Blusher - Minerale blush voor een gezonde blos.
- Foundation - Minerale foundation in poedervorm.

Gebruik ALLEEN deze namen als je specifieke producten aanbeveelt.`;
        
        // Bereid de berichten voor met systeem-prompt, context en gebruikersbericht
        const messages = [
          { role: "system", content: SYSTEM_PROMPT }
        ];
        
        // Voeg context toe als aparte systeembericht
        if (contextText.trim()) {
          messages.push({ 
            role: "system", 
            content: "Belangrijke contextinformatie voor je antwoorden:\n\n" + contextText 
          });
        }
        
        // Voeg beperkte conversatiegeschiedenis toe (max 4 laatste berichten)
        if (conversationHistory.length > 0) {
          const recentHistory = conversationHistory.slice(-4);
          messages.push(...recentHistory);
        }
        
        // Voeg gebruikersbericht toe
        messages.push({ role: "user", content: userMessage });
        
        console.log('API aanroep:', { 
          model: config.model,
          messagesCount: messages.length,
          contextSize: contextText.length
        });
        
        // Maak API aanroep met timeout
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 15000);
        
        const response = await fetch(config.apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${config.apiKey}`
          },
          body: JSON.stringify({
            model: config.model,
            messages: messages,
            temperature: 0.7,
            max_tokens: 500
          }),
          signal: controller.signal
        });
        
        clearTimeout(timeoutId);
        
        if (!response.ok) {
          const errorData = await response.json();
          console.error('API Fout:', errorData);
          throw new Error(`API Fout: ${response.status}`);
        }
        
        const data = await response.json();
        const gptResponse = data.choices[0].message.content;
        
        return { text: gptResponse };
      } catch (error) {
        console.error('Fout bij API aanroep:', error);
        if (error.name === 'AbortError') {
          return { text: "Het lijkt erop dat er een timeout is opgetreden. Kunt u uw vraag nogmaals stellen?" };
        }
        return getDefaultResponse(userMessage);
      }
    }
    
    // Fallback naar standaard antwoorden indien API niet beschikbaar
    function getDefaultResponse(message) {
      const lowerMsg = message.toLowerCase();
      let response = "Bedankt voor uw bericht. Hoe kan ik u verder helpen?";
      
      if (lowerMsg.includes('retour') || lowerMsg.includes('terug')) {
        response = "Ons retourbeleid biedt 30 dagen garantie. U kunt artikelen binnen deze periode retourneren voor een volledige terugbetaling of omruiling.";
      } else if (lowerMsg.includes('verzend') || lowerMsg.includes('levertijd')) {
        response = "Voor bestellingen binnen Nederland duurt de verzending meestal 1-2 werkdagen. Bestellingen geplaatst vóór 15:00 worden dezelfde dag nog verzonden.";
      } else if (lowerMsg.includes('bestseller') || lowerMsg.includes('populair')) {
        response = "Onze bestsellers zijn momenteel de biologische gezichtsverzorgingsproducten en de nieuwste huidtype-specifieke serums.";
      } else if (lowerMsg.includes('korting') || lowerMsg.includes('aanbieding')) {
        response = "We hebben momenteel een mooie aanbieding: 15% korting op uw eerste bestelling met code WELKOM15.";
      } else if (lowerMsg.includes('gevoelig') || lowerMsg.includes('sensitief')) {
        response = "Voor een gevoelige huid adviseren wij producten zonder parfum en irriterende ingrediënten. We hebben speciaal hiervoor een lijn ontwikkeld die de huidbarrière versterkt.";
      } else if (lowerMsg.includes('droog') || lowerMsg.includes('droge')) {
        response = "Voor droge huid adviseren wij rijke, hydraterende producten met ingrediënten zoals hyaluronzuur, ceramiden en plantaardige oliën die de huid voeden.";
      } else if (lowerMsg.includes('product') || lowerMsg.includes('advies')) {
        response = "Op basis van uw vraag kan ik u adviseren om te kijken naar onze bestsellers, die door veel klanten positief beoordeeld zijn.";
      } else {
        response = "Dat weet ik niet zeker, ik zal dit navragen bij een specialist. Kan ik u ondertussen helpen met een ander onderwerp?";
      }
      
      return { text: response };
    }
    
    // ===== UI FUNCTIES =====
    
    // Verzend bericht en verwerk respons
    async function sendMessage(text) {
      addMessage('user', text);
      input.value = '';
      
      // Bewaar bericht in conversatiegeschiedenis
      conversationHistory.push({
        role: "user",
        content: text
      });
      
      // Toon typing indicator
      showTypingIndicator();
      
      try {
        // Zorg dat de kennisbank geladen is
        if (!knowledgeBase.isLoaded) {
          await initializeKnowledgeBase();
        }
        
        // Zoek relevante chunks voor deze vraag
        const relevantChunks = findRelevantChunks(text, config.maxChunksToInclude);
        
        // Controleer direct voor productaanbevelingen, ongeacht de API-respons
        const searchTerm = extractProductSearchTerms(text);
        console.log(`Gebruiker vraagt om: "${text}"`);
        console.log(`Geëxtraheerde zoekterm: "${searchTerm}"`);
        
        // Haal antwoord op via API of fallback
        const response = await callOpenAIWithContext(text, relevantChunks);
        
        // Verberg typing indicator en toon antwoord
        hideTypingIndicator();
        addMessage('bot', response.text);
        
        // Bewaar antwoord in conversatiegeschiedenis
        conversationHistory.push({
          role: "assistant",
          content: response.text
        });
        
        // Alleen productaanbevelingen tonen bij productgerelateerde vragen
        if (searchTerm) {
          // ===== FASE 1: Probeer eerst producten te herkennen in het bot-antwoord =====
          // Deze hebben hogere prioriteit omdat het waarschijnlijk is dat deze producten
          // expliciet door de AI worden aangeraden aan de gebruiker
          const botSearchTerm = extractProductSearchTerms(response.text);
          console.log(`Bot antwoordt met: "${response.text}"`);
          console.log(`Geëxtraheerde zoekterm uit bot antwoord: "${botSearchTerm}"`);
          
          // Zoek naar specifieke productverwijzingen in het antwoord van de bot
          let productMentions = []; // Reset productMentions zodat we alle matches kunnen verzamelen
          let directProductMatch = null; // Definieer directProductMatch om bugs te voorkomen
          
          // Lijst met alle daadwerkelijke producten, gegroepeerd op merk
          const allProducts = {
            'Éminence': [
              'Sun Defense Minerals - Fair', 'Sun Defense Minerals - Light',
              'Sun Defense Minerals - Medium', 'Sun Defense Minerals - Tan',
              'Sun Defense Minerals - Deep', 'Sun Defense Minerals - Sheer',
              'Sun Defense Minerals', 'Stone Crop Whip Moisturizer', 
              'Mangosteen Daily Resurfacing Cleanser', 'Turmeric Energizing Treatment',
              'Strawberry Rhubarb Masque', 'Strawberry Rhubarb Hyaluronic Hydrator',
              'Eight Greens Phyto Masque HOT', 'Bakuchiol + Niacinamide Moisturizer',
              'Radiant Protection SPF Fluid', 'Daily Defense Tinted SPF',
              'Citrus & Kale Potent C+E Serum', 'Yam & Pumpkin Peel 5%'
            ],
            'Nutrins': [
              'Liposomale Multivitamine', 'Proven 25', 'ProVen 50',
              'Vitamine C', 'Liposomale Glutathion', 'Liposomale FLM-X',
              'BallastVezels', 'Omega ADEK', 'Volledige Vezels'
            ],
            'Labrains': [
              'Cleansing Cream', 'Pore Perfect Cleanser', 'Daily Face Cream voor Jonge Huid',
              'BB Cream - ultra light', 'BB Cream - light', 'BB Cream - medium',
              'BB Cream', 'Rosa Cease Serum', 'Renovation Sculpter Cream',
              'Renovation Sculptor Serum', 'Skin Perfecting Facial Peeling Mask',
              'Pore Perfect Serum', 'Rosa Cease And Pore Perfect Cream'
            ],
            'Mintenz': [
              '501 Concealer kwast', '506 Small pointed brush', '509 Schuine kwast small',
              'Kabuki Long Foundation', 'Mini Kabuki Foundation', 'Primer',
              'Highlighter', 'Bronzer', 'Finisher', 'Blusher', 'Foundation'
            ]
          };

          // Zoek naar directe vermelding van producten in het bot-antwoord, met voorkeur voor specifieke varianten
          for (const brand in allProducts) {
            for (const product of allProducts[brand]) {
              // Precieze match met productvariant heeft hoogste prioriteit
              if (product.includes(' - ')) {
                const regex = new RegExp(`\\b${product.replace(/[-]/g, '[\\-\\–]')}\\b`, 'i');
                if (regex.test(response.text)) {
                  console.log(`Exacte productvariant gevonden: ${product}`);
                  productMentions.push(product);
                  if (!directProductMatch) {
                    directProductMatch = product; // Bewaar eerste variant match als hoogste prioriteit
                  }
                }
              }
            }
          }
          
          // Tweede pas: zoek naar generieke producten zonder variant specificatie
          for (const brand in allProducts) {
            for (const product of allProducts[brand]) {
              // Alleen generieke producten zonder varianten-specifieke formaat
              if (!product.includes(' - ')) {
                const regex = new RegExp(`\\b${product}\\b`, 'i');
                if (regex.test(response.text) && !productMentions.includes(product)) {
                  console.log(`Generiek product gevonden: ${product}`);
                  productMentions.push(product);
                }
              }
            }
          }
          
          // Speciale controle op producten die in dezelfde zin worden genoemd met "en" of andere voegwoorden
          console.log(`Totaal ${productMentions.length} producten gevonden in bot antwoord: ${productMentions.join(', ')}`);
          
          // Als we meer dan 3 producten hebben gevonden, beperk tot de eerste 3
          if (productMentions.length > 3) {
            console.log(`Meer dan 3 producten gevonden, beperkend tot de eerste 3`);
            productMentions = productMentions.slice(0, 3);
          }
          
          // Als geen specifieke variant is gevonden, probeer algemene productnamen te vinden
          if (!directProductMatch) {
            for (const brand in allProducts) {
              for (const product of allProducts[brand]) {
                // Alleen generieke producten zonder varianten-specifieke formaat
                if (!product.includes(' - ')) {
                  const regex = new RegExp(`\\b${product}\\b`, 'i');
                  if (regex.test(response.text)) {
                    productMentions.push(product);
                    break;
                  }
                }
              }
            }
          }
          
          // Als we directe productvermelding vinden, gebruik die met hoogste prioriteit
          let productResults = [];
          let selectedSearchTerm = null;
          
          if (directProductMatch) {
            // Gebruik de specifieke productvariant met hoogste prioriteit
            console.log(`Directe productvariant match gevonden in bot-antwoord: ${directProductMatch}`);
            selectedSearchTerm = directProductMatch;
            
            // Haal producten op met deze exacte term
            productResults = await fetchProductsFromStorefront(selectedSearchTerm);
          }
          else if (productMentions.length > 0) {
            // VERBETERING: Haal alle genoemde producten op, niet alleen de eerste
            console.log(`${productMentions.length} directe productvermeldingen gevonden in bot-antwoord: ${productMentions.join(', ')}`);
            
            // Haal maximaal 3 verschillende producten op die in het antwoord worden genoemd
            const productPromises = productMentions.slice(0, 3).map(productName => 
              fetchProductsFromStorefront(productName, 1)
            );
            
            // Wacht tot alle producten zijn opgehaald
            const productsArrays = await Promise.all(productPromises);
            
            // Combineer de resultaten in één array (flatten)
            productResults = productsArrays.flat();
            
            console.log(`Succesvol ${productResults.length} producten opgehaald voor de genoemde producten`);
            
            // Als we geen producten hebben gevonden, val dan terug op de eerste vermelding
            if (productResults.length === 0 && productMentions.length > 0) {
              selectedSearchTerm = productMentions[0];
              productResults = await fetchProductsFromStorefront(selectedSearchTerm);
            }

            // Verwijder dubbele producten door te filteren op unieke handles
            if (productResults.length > 0) {
              // Maak een Set om unieke handles bij te houden
              const uniqueHandles = new Set();
              
              // Filter producten met unieke handles
              productResults = productResults.filter(product => {
                if (uniqueHandles.has(product.handle)) {
                  console.log(`Dubbel product verwijderd: ${product.title}`);
                  return false;
                }
                uniqueHandles.add(product.handle);
                return true;
              });
              
              console.log(`Na verwijderen van duplicaten: ${productResults.length} unieke producten over`);
            }
          }
          // ===== FASE 2: Als geen directe vermelding, probeer de geëxtraheerde zoekterm uit het bot-antwoord =====
          else if (botSearchTerm) {
            console.log(`Zoeken naar productaanbevelingen op basis van bot-antwoord: "${botSearchTerm}"`);
            selectedSearchTerm = botSearchTerm;
            
            // Haal producten op met deze geëxtraheerde term
            productResults = await fetchProductsFromStorefront(botSearchTerm);
          }
          // ===== FASE 3: Als alles hierboven faalt, gebruik de zoekterm uit de gebruikersvraag =====
          else if (searchTerm) {
            console.log(`Zoeken naar productaanbevelingen op basis van gebruikersvraag: "${searchTerm}"`);
            selectedSearchTerm = searchTerm;
            
            // Haal producten op
            productResults = await fetchProductsFromStorefront(searchTerm);
          }
          
          console.log(`Gevonden ${productResults.length} producten op basis van zoekterm: "${selectedSearchTerm}"`);
          
          // Als we producten hebben gevonden, toon ze
          if (productResults.length > 0) {
            // Verwijder eventuele duplicaten op basis van product handle
            const uniqueResults = [];
            const seenHandles = new Set();
            
            for (const product of productResults) {
              if (!seenHandles.has(product.handle)) {
                seenHandles.add(product.handle);
                uniqueResults.push(product);
              } else {
                console.log(`Duplicaat verwijderd: ${product.title}`);
              }
            }
            
            // Update de aanbevolen producten met alleen unieke items
            recommendedProducts = uniqueResults;
            
            // Als we minder dan 3 unieke producten hebben, probeer aanvullende producten op te halen
            if (uniqueResults.length < 3 && selectedSearchTerm) {
              console.log(`Slechts ${uniqueResults.length} unieke producten gevonden, zoeken naar aanvullende producten...`);
              const additionalResults = await fetchProductsFromStorefront('bestsellers', 3 - uniqueResults.length);
              
              // Voeg alleen niet-dubbele producten toe
              for (const product of additionalResults) {
                if (!seenHandles.has(product.handle)) {
                  seenHandles.add(product.handle);
                  uniqueResults.push(product);
                  if (uniqueResults.length >= 3) break;
                }
              }
              
              // Update recommendedProducts met de nieuwe lijst
              recommendedProducts = uniqueResults;
            }
            
            // Toon de unieke producten
            console.log(`Tonen van ${uniqueResults.length} unieke aanbevolen producten`);
            displayRecommendedProducts(uniqueResults);
          } 
          // Als er geen producten worden gevonden, probeer een meer algemene zoekopdracht
          else if (selectedSearchTerm && selectedSearchTerm !== 'huidverzorging') {
            console.log(`Probeer meer algemene zoekopdracht: "huidverzorging"`);
            const fallbackResults = await fetchProductsFromStorefront('huidverzorging', 3);
            
            if (fallbackResults.length > 0) {
              // Controleer op duplicaten, zelfs voor fallback resultaten
              const uniqueFallbackResults = [];
              const seenHandles = new Set();
              
              for (const product of fallbackResults) {
                if (!seenHandles.has(product.handle)) {
                  seenHandles.add(product.handle);
                  uniqueFallbackResults.push(product);
                }
              }
              
              recommendedProducts = uniqueFallbackResults;
              displayRecommendedProducts(uniqueFallbackResults);
            }
          }
        } else {
          // Geen productgerelateerde vraag, verberg aanbevelingen
          console.log('Geen productgerelateerde vraag gedetecteerd, geen aanbevelingen tonen');
          recommendedProducts = [];
          displayRecommendedProducts([]);
          chatbot.classList.remove('has-recommendations');
          productsContainer.classList.remove('has-products');
        }
        
        // Beperk geschiedenis tot 10 berichten
        if (conversationHistory.length > 10) {
          conversationHistory = conversationHistory.slice(-10);
        }
      } catch (error) {
        console.error('Fout bij het verwerken van bericht:', error);
        
        // Verberg typing indicator en toon foutmelding
        hideTypingIndicator();
        addMessage('bot', 'Excuses, er is een fout opgetreden bij het verwerken van uw bericht. Kunt u het later nog eens proberen?');
      }
    }
    
    // Voeg bericht toe aan de chatinterface
    function addMessage(type, text) {
      const messageEl = document.createElement('div');
      messageEl.className = `chatbot-message ${type}`;
      
      const bubble = document.createElement('div');
      bubble.className = 'message-bubble';
      
      // Voeg ondersteuning toe voor HTML en regeleinden, zodat emoji's en opmaak correct worden weergegeven
      // Vervang regeleinden met <br> tags voor correcte weergave
      const formattedText = text
        .replace(/\n/g, '<br>')
        .replace(/(\d+\.)/g, '<strong>$1</strong>') // Maak genummerde punten vetgedrukt
        .replace(/→/g, '<span style="color:#127059;">→</span>') // Maak pijlen groen
        .replace(/(Gebruik:)/g, '<strong style="color:#D4AF37;">$1</strong>') // Maak "Gebruik:" goud en vetgedrukt
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Zet Markdown **tekst** om naar <strong>tekst</strong>
        .replace(/\*(.*?)\*/g, '<em>$1</em>'); // Zet Markdown *tekst* om naar <em>tekst</em>
      
      bubble.innerHTML = formattedText;
      
      const timeEl = document.createElement('div');
      timeEl.className = 'message-time';
      timeEl.textContent = getCurrentTime();
      
      messageEl.appendChild(bubble);
      messageEl.appendChild(timeEl);
      
      messagesContainer.appendChild(messageEl);
      scrollToBottom();
    }
    
    // Simuleer typgedrag voor welkomstbericht
    function simulateTyping(text) {
      showTypingIndicator();
      
      // Vertraging op basis van tekstlengte, tussen 1-2 seconden
      const delay = Math.min(2000, Math.max(1000, text.length * 20));
      
      setTimeout(() => {
        hideTypingIndicator();
        addMessage('bot', text);
      }, delay);
    }
    
    // Open/sluit chatbot
    function toggleChatbot() {
      isOpen = !isOpen;
      console.log(`Chatbot ${isOpen ? 'openen' : 'sluiten'}`);
      
      if (isOpen) {
        chatbot.classList.add('chatbot-open');
        notification.classList.add('hide');
        
        // Als er productaanbevelingen zijn, toon deze direct
        setTimeout(() => {
          if (chatbot.classList.contains('has-recommendations') && 
              productsContainer.classList.contains('has-products')) {
            console.log('Bestaande productaanbevelingen weergeven bij openen chatbot');
            
            // Forceer direct de juiste weergave van productaanbevelingen
            productsContainer.style.display = 'flex';
            productsContainer.style.opacity = '1';
            productsContainer.style.visibility = 'visible';
            
            // Log de css properties voor debug
            const computedStyle = window.getComputedStyle(productsContainer);
            console.log('Product container CSS:', {
              display: computedStyle.display,
              opacity: computedStyle.opacity,
              visibility: computedStyle.visibility
            });
          }
        }, 300);
        
        setTimeout(() => input.focus(), 300);
      } else {
        chatbot.classList.remove('chatbot-open');
        
        // Zorg er altijd voor dat de productaanbevelingen container correct wordt verborgen
        setTimeout(() => {
          if (!chatbot.classList.contains('chatbot-open')) {
            productsContainer.style.opacity = '0';
            productsContainer.style.pointerEvents = 'none';
            productsContainer.style.visibility = 'hidden';
          }
        }, 300);
      }
    }
    
    // Toon notificatiebubble
    function showNotification() {
      if (!isOpen) {
        notification.classList.remove('hide');
      }
    }
    
    // Scroll naar beneden in berichtvenster
    function scrollToBottom() {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
    
    // Huidige tijd in formaat 00:00
    function getCurrentTime() {
      const now = new Date();
      return now.getHours().toString().padStart(2, '0') + ':' + 
             now.getMinutes().toString().padStart(2, '0');
    }
    
    // Toon typing indicator
    function showTypingIndicator() {
      isTyping = true;
      const typingBubble = document.createElement('div');
      typingBubble.className = 'typing-bubble';
      typingBubble.id = 'typing-bubble';
      typingBubble.innerHTML = '<div class="typing-indicator"><span></span><span></span><span></span></div>';
      messagesContainer.appendChild(typingBubble);
      scrollToBottom();
    }
    
    // Verberg typing indicator
    function hideTypingIndicator() {
      isTyping = false;
      const typingBubble = document.getElementById('typing-bubble');
      if (typingBubble && messagesContainer.contains(typingBubble)) {
        messagesContainer.removeChild(typingBubble);
      }
    }
    
    // ===== EVENT LISTENERS =====
    
    // Event listeners
    button.addEventListener('click', toggleChatbot);
    closeButton.addEventListener('click', toggleChatbot);
    
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const message = input.value.trim();
      if (message) {
        sendMessage(message);
      }
    });
    
    const suggestionChips = chatbot.querySelectorAll('.suggestion-chip');
    suggestionChips.forEach(chip => {
      chip.addEventListener('click', function() {
        input.value = chip.textContent;
        sendMessage(input.value);
      });
    });
    
    // ===== INITIALISATIE =====
    
    // Initialize kennisbank bij laden van pagina
    initializeKnowledgeBase();
    
    // Test de Storefront API als token aanwezig is
    if (config.storefrontApiToken) {
      console.log("Storefront API token aanwezig, testen van functionaliteit...");
      
      // Test een eenvoudige query om te zien of de API werkt
      fetchProductsFromStorefront("bestseller", 1)
        .then(products => {
          if (products.length > 0) {
            console.log("Storefront API werkt correct:", products.length, "product(en) opgehaald");
          } else {
            console.warn("Storefront API query gaf geen resultaten terug");
          }
        })
        .catch(error => {
          console.error("Storefront API test mislukt:", error);
        });
    } else {
      console.warn("Geen Storefront API token gevonden, productaanbevelingen zijn uitgeschakeld");
    }
    
    // Toon welkomstbericht
    setTimeout(() => {
      simulateTyping(config.welcomeMessage);
      showNotification();
      
      // Voeg welkomstbericht toe aan conversatiegeschiedenis
      conversationHistory.push({
        role: "assistant",
        content: config.welcomeMessage
      });
    }, 1000);

    // Aangepaste fullscreen functionaliteit die rekening houdt met productaanbevelingen
    chatbot.querySelector('#chatbot-fullscreen-btn').addEventListener('click', function() {
      const isInFullscreen = chatbot.classList.contains('fullscreen-mode');
      
      if (isInFullscreen) {
        // Als we uit fullscreen gaan, zorg ervoor dat producten zichtbaar blijven
        chatbot.classList.remove('fullscreen-mode');
      } else {
        // Als we naar fullscreen gaan en er zijn producten, pas de layout aan
        chatbot.classList.add('fullscreen-mode');
        
        // Als er productaanbevelingen zijn, pas de layout aan
        if (chatbot.classList.contains('has-recommendations')) {
          // Hier zou extra code kunnen komen voor fullscreen met producten
          // Bijvoorbeeld het chatvenster smaller maken als er productaanbevelingen zijn
        }
      }
    });
  })();
}); 